/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { StyledButton } from "./styles";
import { ReactComponent as ResetIcon } from '../../assets/images/reset-icon.svg'

export const ResetButton = ({ onClick, status }) => {

  return (
    <StyledButton
      variant="outlined"
      onClick={onClick}
      startIcon={<ResetIcon style={{
        color: status ? 'rgba(0, 0, 0, 0.26)' : "#2b4fb9",
        marginTop: '-3px'
      }} />}
      data-testid="filter-section-reset-btn"
      disabled={status}
    >
      Reset
    </StyledButton>
  );
};
